<div class="search-box flex">
  <input
    [(ngModel)]="searchText"
    (keyup)="onSearchInputChange($event)"
    class="form-control"
    value=""
    [placeholder]="'SHARED.SEARCH' | translate"
    tabindex="-1"
  />
  <div class="icon-search">
    <app-svg-icon
      [icon]="iconName"
      padding="8px"
      [color]="'#BDBDBD'"
    ></app-svg-icon>
  </div>
</div>
